<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="16">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="customerChains" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="name" :label="$t('common.name')" width="200"></el-table-column>
            <el-table-column :label="$t('masters.validationRules')">
                <template slot-scope="scope">
                    <el-tag v-for="rule in scope.row.validationRules" :key="rule" type="info" style="margin-right: 10px;">{{rule}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column :label="$t('masters.storeNumberRequired')">
                <template slot-scope="scope">
                    <i class="el-icon-check" v-if="scope.row.storeNumberRequired"></i>
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" :width="$isSuperAdmin ? 160 : 116 + 'px'">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editCustomerChain(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteCustomerChain(scope.row.id)" v-if="$isSuperAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <create-update-customer-chain-dialog :customerChainId="customerChainToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendCustomerChain"></create-update-customer-chain-dialog>
    </div>
</template>

<script>
    import CreateUpdateCustomerChainDialog from './CreateUpdateCustomerChainDialog.vue'
    import api from '../api'

    export default {
        name: 'customer-chain-list',
        components: {
            CreateUpdateCustomerChainDialog
        },
        data() {
            return {
                customerChains: [],
                loading: true,
                dialogVisible: false,
                customerChainToEdit: null,
                filter: {
                    text: undefined
                },
                currentPage: 1,
                total: 0
            }
        },
        created() {
            this.loadCustomerChains();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadCustomerChains();
                }
            }
        },
        methods: {
            download() {
                api.download(this.filter);
            },
            loadCustomerChains() {
                this.loading = true
                api.getCustomerChains(this.currentPage, this.filter.text).then(response => {
                    this.loading = false
                    this.customerChains = response.data.items
                    this.total = response.data.total
                })
            },
            appendCustomerChain(event) {
                this.loadCustomerChains();
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadCustomerChains();
            },
            editCustomerChain(id) {
                this.customerChainToEdit = id
                this.dialogVisible = true
            },
            editFinished() {
                this.customerChainToEdit = null
                this.dialogVisible = false
            },
            deleteCustomerChain(id) {
                this.$confirm(
                    this.$t('common.thisWillDeleteCustomerChainContinue'),
                    'Warning',
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: 'warning'
                    }
                ).then(() => {
                    api.deleteCustomerChain(id).then(() => {
                        this.loadCustomerChains();
                        this.$message({
                            type: 'success',
                            message: this.$t('common.deleteCompleted')
                        })
                    });
                }).catch(_ => {});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/customerchains/components/CustomerChainList.vue